import { useContext } from 'react';
import { IVariantIconV2WorldMarker } from 'react-give-me-map';
import { CtxEdit } from 'session/ctxEdit';

import { SelectedMarkerIconCommon } from 'components/site/general/singleSelect/SelectedMarkerV2/SelectedMarkerIconCommon';
import 'components/site/general/singleSelect/SelectedMarkerV2/style.css';

interface Props {
    markerId: string;
}

export const SelectedMarkerV2VariantIcon = (props: Props) => {
    const ctxEdit = useContext(CtxEdit);

    const variantIconMarkers = ctxEdit.worldMarkers.filter(
        (e): e is IVariantIconV2WorldMarker => e.elementType === 'v2/variant_icon'
    );

    return (
        <SelectedMarkerIconCommon
            markerId={props.markerId}
            type={'v2/variant_icon'}
            allMarkersOfType={variantIconMarkers}
        />
    );
};
